// extracted by mini-css-extract-plugin
export default {"section":"TermsSection_section__43A+v","header":"TermsSection_header__iVMWD","grid":"TermsSection_grid__sTGhk","card":"TermsSection_card__vwuyd"};